module.exports = __webpack_public_path__ + "c6709de136dee21e1946dfc391137f28.png";